import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
  useTheme,
} from '@mui/material';

interface RenameDialogProps {
  open: boolean;
  title: string;
  placeholderText: string;
  onClose: () => void;
  onSubmit: (name: string) => void;
  defaultValue?: string;
}

const RenameDialog: React.FC<RenameDialogProps> = ({ open, title, placeholderText, onClose, onSubmit, defaultValue}) => {
  const [name, setName] = useState('');
  const theme = useTheme();

  useEffect(() => {
    if (defaultValue !== undefined) {
        setName(defaultValue);
    }
  }, [defaultValue])

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={placeholderText}
          type="text"
          fullWidth
          variant="outlined"
          value={name}
          onChange={(event) => setName(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" color="primary" onClick={() => onSubmit(name)}>Save</Button>
      </DialogActions>
    </Dialog>
  );
};

export default RenameDialog;
